import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'vw-progress-bar',
    imports: [
        NgClass
    ],
    templateUrl: './progress-bar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  @Input() progress!: number;
  @Input() singleColor: boolean = false;
  @Input() colorClass: string = 'bg-primary';
  @Input() secondColorClass: string = 'bg-[#F0EFEF]';

}
